module.exports = __webpack_public_path__ + "ad83a16c79d668cfb78efc2a9b108fb7.jpg";